import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { WhatsAppGlobalSettings } from '@/components/whatsapp/WhatsAppGlobalSettings';
import { MediaReprocessingCard } from '@/components/whatsapp/MediaReprocessingCard';
import { ThumbnailReprocessingCard } from '@/components/whatsapp/ThumbnailReprocessingCard';
import { SharedWhatsAppSession } from '@/components/whatsapp/SharedWhatsAppSession';
import { WhatsAppServersAdmin } from '@/components/whatsapp/WhatsAppServersAdmin';
import { SettingsSharedConnection } from '@/components/whatsapp/SettingsSharedConnection';
import { useAuth } from '@/hooks/useAuth';
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export default function WhatsAppSettings() {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (!user) return;

      try {
        const { data, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .eq('role', 'admin')
          .single();

        if (!error && data) {
          setIsAdmin(true);
        }
      } catch (error) {
        console.error('Error checking admin role:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAdminRole();
  }, [user]);

  if (loading) {
    return (
      <div className="container mx-auto py-8">
        <div className="flex items-center justify-center">
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  // Non-admin users: show only shared connection option
  if (!isAdmin) {
    return (
      <div className="container mx-auto py-8 overflow-auto h-full">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Configurações do WhatsApp</h1>
          <p className="text-muted-foreground mt-2">
            Configure sua conexão WhatsApp
          </p>
        </div>
        <SettingsSharedConnection />
      </div>
    );
  }

  // Admin users: show full admin panel with tabs
  return (
    <div className="container mx-auto py-8 overflow-auto h-full">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Configurações do WhatsApp</h1>
        <p className="text-muted-foreground mt-2">
          Gerencie as configurações de WhatsApp e Evolution API
        </p>
      </div>

      <Tabs defaultValue="shared" className="w-full">
        <TabsList className="grid w-full" style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
          <TabsTrigger value="shared">
            Sessão Central
          </TabsTrigger>
          <TabsTrigger value="servers">
            Servidores
          </TabsTrigger>
          <TabsTrigger value="global">
            Configuração Global
          </TabsTrigger>
          <TabsTrigger value="tools">
            Ferramentas
          </TabsTrigger>
        </TabsList>

        <TabsContent value="shared" className="space-y-4">
          <SharedWhatsAppSession />
        </TabsContent>

        <TabsContent value="servers" className="space-y-4">
          <WhatsAppServersAdmin />
        </TabsContent>

        <TabsContent value="global" className="space-y-4">
          <WhatsAppGlobalSettings />
        </TabsContent>

        <TabsContent value="tools" className="space-y-4">
          <ThumbnailReprocessingCard />
          <MediaReprocessingCard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
